var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeryUnhealthyFaceBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Very_Unhealthy_icon",
    "data-name": "Very Unhealthy icon",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M414.5,388h14.359a.141.141,0,0,1,.141.141V402.5A14.5,14.5,0,0,1,414.5,417h0A14.5,14.5,0,0,1,400,402.5h0A14.5,14.5,0,0,1,414.5,388Z",
    transform: "translate(-400 -388)",
    fill: "none",
    stroke: "#030504",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(6.089 5.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M423.607,415a7.645,7.645,0,0,0-13.994,0l-1.385-.54a9.13,9.13,0,0,1,16.765,0Z",
    transform: "translate(-408.199 -399.054)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 7.577,
    height: 1.487,
    transform: "translate(0.002 5.358) rotate(-45)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 1.487,
    height: 7.577,
    transform: "translate(0 1.052) rotate(-45.002)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 7.579,
    height: 1.487,
    transform: "translate(10.41 5.359) rotate(-45)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 1.487,
    height: 7.579,
    transform: "translate(10.41 1.052) rotate(-45.004)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryUnhealthyFaceBlack);
export default __webpack_public_path__ + "static/media/veryUnhealthyFaceBlack.4c2e6add52c102df23ac7137b2ec066c.svg";
export { ForwardRef as ReactComponent };